export const UserRole = {
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN',
} as const;
